var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectTypeNaturalFloodManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.99996L2.07981 5.91128C2.70526 5.21634 3.76815 5.14008 4.48639 5.73862C5.13148 6.27619 6.06852 6.27619 6.71361 5.73862L6.8 5.66663C7.49514 5.08735 8.50486 5.08735 9.2 5.66663L9.28639 5.73862C9.93148 6.27619 10.8685 6.27619 11.5136 5.73862C12.2319 5.14008 13.2947 5.21634 13.9202 5.91128L14 5.99996",
    stroke: "#0D576E",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.66671L2.07981 8.57803C2.70526 7.88309 3.76815 7.80683 4.48639 8.40537C5.13148 8.94294 6.06852 8.94294 6.71361 8.40537L6.8 8.33337C7.49514 7.75409 8.50486 7.75409 9.2 8.33337L9.28639 8.40537C9.93148 8.94294 10.8685 8.94294 11.5136 8.40537C12.2319 7.80683 13.2947 7.88309 13.9202 8.57803L14 8.66671",
    stroke: "#0D576E",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.3333L2.07981 11.2447C2.70526 10.5497 3.76815 10.4735 4.48639 11.072C5.13148 11.6096 6.06852 11.6096 6.71361 11.072L6.8 11C7.49514 10.4207 8.50486 10.4207 9.2 11L9.28639 11.072C9.93148 11.6096 10.8685 11.6096 11.5136 11.072C12.2319 10.4735 13.2947 10.5497 13.9202 11.2447L14 11.3333",
    stroke: "#0D576E",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeNaturalFloodManagement);
export default __webpack_public_path__ + "static/media/project-type-natural-flood-management.0b89572056533c1045b6acfcd8b67eb0.svg";
export { ForwardRef as ReactComponent };